import React from "react"
import Modal from "react-bootstrap/lib/Modal"
import Button from "react-bootstrap/lib/Button"

export default function AlertModal(props) {
  // -------------------------------------
  // Props destructuring
  // -------------------------------------

  const { show, title, text, onClose } = props

  // -------------------------------------
  // Hooks (e.g. useState, useMemo ...)
  // -------------------------------------

  // -------------------------------------
  // Effects
  // -------------------------------------

  // -------------------------------------
  // Component functions
  // -------------------------------------

  // -------------------------------------
  // Component local variables
  // -------------------------------------

  // -------------------------------------

  return (
    <Modal show={show} onHide={onClose}>
      <Modal.Header>
        <Modal.Title>{title}</Modal.Title>
        <button
          className="close"
          aria-label="Close"
          data-dismiss="modal"
          type="button"
          onClick={onClose}
        >
          <i className="fal fa-times" />
        </button>
      </Modal.Header>

      <Modal.Body>{text}</Modal.Body>

      <Modal.Footer>
        <Button className="btn-light btn-sm" onClick={onClose}>
          Ok
        </Button>
      </Modal.Footer>
    </Modal>
  )
}
